var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 8,
    viewBox: "0 0 14 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Arrow - Down 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke 1 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.726027 0.641066C0.970105 0.396988 1.36583 0.396988 1.60991 0.641066L7.0013 6.03246L12.3927 0.641066C12.6368 0.396988 13.0325 0.396988 13.2766 0.641066C13.5207 0.885144 13.5207 1.28087 13.2766 1.52495L7.44324 7.35828C7.19917 7.60236 6.80344 7.60236 6.55936 7.35828L0.726027 1.52495C0.481949 1.28087 0.481949 0.885144 0.726027 0.641066Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevron_down.4ad1c50df34d6f8398bdbac61f08831c.svg";
export { ForwardRef as ReactComponent };